export default "__VITE_ASSET__CHh$$5ac__"